import axios from "axios";
import { useState } from "react";
import MessageToster from "../component/MessageToster";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import { getApiHeaders } from "../utils/helpers";
import { PASSWORD_REGEX } from "../utils/regex";
import { BASE_URL } from "../api";
import { useHandleError } from "../hooks/useHandleError";

export default function ChangePassword({ isModal = false }) {
    const handleError = useHandleError();
    const [loading, setLoading] = useState(false);
    const [pass, setPass] = useState({
        old_password: "",
        new_password: "",
        confirm_password: "",
    });
    const [showPass, setShowPass] = useState({
        old_password: false,
        new_password: false,
        confirm_password: false,
    });

    const togglePassword = (field) => {
        setShowPass(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPass({ ...pass, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const validate = () => {
        const validationErrors = {};

        if (!pass.old_password) validationErrors.old_password = "Old password is required";
        if (!pass.new_password) {
            validationErrors.new_password = "New password is required";
        } else if (pass.new_password.length < 8) {
            validationErrors.new_password = "Password must be at least 8 characters long";
        } else if (!PASSWORD_REGEX.test(pass.new_password)) {
            validationErrors.new_password =
                "Password must include uppercase, lowercase, number, and special character";
        }

        if (!pass.confirm_password) {
            validationErrors.confirm_password = "Confirm password is required";
        } else if (pass.new_password && pass.confirm_password !== pass.new_password) {
            validationErrors.confirm_password = "Password and confirm password do not match";
        }
        if (
            pass.old_password &&
            pass.new_password &&
            pass.old_password === pass.new_password
        ) {
            validationErrors.new_password = "New password must be different from old password";
        }

        return validationErrors;
    };

    const handleChangePassword = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const mid = sessionStorage.getItem("mid");

        if (!mid) {
            MessageToster("error", "Session expired. Please login again.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/account/update_password`,
                {
                    mid,
                    old_password: pass.old_password.trim(),
                    password: pass.new_password.trim(),
                },
                {
                    headers: getApiHeaders(),
                }
            );

            if (response.data.code === 200) {
                MessageToster("success", response.data.message);
                setPass({ old_password: "", new_password: "", confirm_password: "" });
            } else {
                MessageToster("error", response.data.message);
            }
        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };


    const Content = (
        <div className={isModal ? "card col-12 p-0 border-0 shadow-none mb-0" : "card col-lg-6 p-0"}>
            <div className="card-body">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleChangePassword();
                }}>
                    {["old_password", "new_password", "confirm_password"].map((field, idx) => (
                        <div className="mb-3" key={idx}>
                            <label className="form-label">
                                {field.replace("_", " ").replace(/\b\w/g, l => l.toUpperCase())}:
                            </label>
                            <div className="input-group">
                                <input
                                    type={showPass[field] ? "text" : "password"}
                                    className="form-control"
                                    name={field}
                                    placeholder={`Enter ${field.replace("_", " ")}`}
                                    value={pass[field]}
                                    onChange={handleChange}
                                />
                                <button
                                    className="btn btn-light"
                                    type="button"
                                    id="password-addon"
                                    onClick={() => togglePassword(field)}
                                >
                                    {
                                        showPass[field] ?
                                            <i className="mdi mdi-eye-outline" />
                                            :
                                            <i className="mdi mdi-eye-off-outline" />
                                    }

                                </button>
                            </div>
                            {errors[field] && <p className="text-danger mb-0">{errors[field]}</p>}
                        </div>
                    ))}
                    <div className="d-flex justify-content-end">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Changing..." : "Change Password"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );

    if (isModal) {
        return Content;
    }

    return (
        <div id="layout-wrapper">
            <Topbar />
            <Sidebar />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <h2 className="fw-700 mb-3">Change Password</h2>
                        <div className="row mx-0 justify-content-center">
                            {Content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}